<div [formGroup]="form">

  <his-plam [label]="widget.kind !== 'checkbox' ? (widget.label | hisUi) : ' '">
    <div>
      @switch (widget.kind) {
        @case ('checkbox') {
          <his-search-checkbox
            #content
            [widget]="widget"
            [isFirstInputElement]="isFirstInputElement"
            (changed)="setOptionValue()">
          </his-search-checkbox>
        }
        @case ('input') {
          <his-search-input
            #content
            [widget]="widget"
            [isFirstInputElement]="isFirstInputElement"
            (changed)="setValue($event)">
          </his-search-input>
        }
        @case ('calendar') {
          <his-search-calendar
            #content
            [widget]="widget"
            [isFirstInputElement]="isFirstInputElement"
            (changed)="setValue($event)">
          </his-search-calendar>
        }
        @case ('dropdown') {
          <his-search-autocomplete
            #content
            [widget]="widget"
            [minLength]="widget.minLength"
            [limit]="widget.limit"
            [showDropdownIcon]="widget.showDropdownIcon"
            [showUnequalOption]="widget.showUnequalOption"
            [isFirstInputElement]="isFirstInputElement"
            [selectFrom]="widget.optionsKey"
            [configFile]="widget.configFile"
            (changed)="setValue($event)">
          </his-search-autocomplete>
        }
        @case ('multi-dropdown') {
          <his-search-multiselect
            #content
            [widget]="widget"
            [uid]="widget.uid"
            [selectedOptions]="widget.value ? widget.value : []"
            [minLength]="widget.minLength"
            [limit]="widget.limit"
            [showDropdownIcon]="widget.showDropdownIcon"
            [showUnequalOption]="widget.showUnequalOption"
            [isFirstInputElement]="isFirstInputElement"
            (changed)="setValue($event)">
          </his-search-multiselect>
        }
        <!-- autocomplete suggestions are loaded lazely by the component itself from the given searchEntity -->
        <!-- widget is only passed to let the plam extract attributes like helptext from the search config file -->
        @case ('search-select') {
          <his-search-select
            #content
            [widget]="widget"
            [uid]="widget.uid"
            [selectedOptions]="widget.value ? widget.value : []"
            [searchEntity]="widget.searchEntity"
            [searchConfigFile]="widget.searchConfigFile"
            [selectedOptionsIdColumn]="widget.selectedOptionsIdColumn"
            [selectedOptionsLabelColumn]="widget.selectedOptionsLabelColumn"
            [minLength]="widget.minLength"
            [limit]="widget.limit"
            [showDropdownIcon]="widget.showDropdownIcon"
            [showUnequalOption]="widget.showUnequalOption"
            [isFirstInputElement]="isFirstInputElement"
            (changed)="setValue($event)"
            [showTableFilter]="widget.showSearchFilter">
          </his-search-select>
        }
        <!-- tree data is loaded in his-widget.service.ts -->
        <!-- widget is only passed to let the plam extract attributes like helptext from the search config file -->
        @case ('tree-select') {
          <his-search-tree-select
            #content
            [widget]="widget"
            [uid]="widget.uid"
            [treename]="widget.treeName"
            [tree]="widget.tree"
            [selectedData]="widget.value ? widget.value : []"
            [title]="widget.label | hisUi"
            [minLength]="widget.minLength"
            [limit]="widget.limit"
            [showDropdownIcon]="widget.showDropdownIcon"
            [showUnequalOption]="widget.showUnequalOption"
            [isFirstInputElement]="isFirstInputElement"
            (changed)="setValue($event)">
          </his-search-tree-select>
        }
        @default {
          <div>
            Widget kind '{{widget.kind}}' not supported.
          </div>
        }
      }
    </div>
  </his-plam>

  @if (showErrors && !isValid) {
    <div [style.color]="'red'">
      @for (error of widget.errors; track error) {
        <div>{{error}}</div>
      }
    </div>
  }
</div>
